import axios from "axios";
import {
  BITBUCKET_AUTH_URL,
  BITBUCKET_TOKEN_URL,
  CLIENT_ID,
  CLIENT_SECRET,
  REDIRECT_URI,
  clearCache,
} from "./bitbucketCore";

// Auth functions
export const getAuthUrl = () => {
  return `${BITBUCKET_AUTH_URL}?client_id=${CLIENT_ID}&response_type=code&redirect_uri=${REDIRECT_URI}`;
};

export const exchangeCodeForToken = async (code) => {
  try {
    const response = await axios.post(
      BITBUCKET_TOKEN_URL,
      new URLSearchParams({
        grant_type: "authorization_code",
        code,
        redirect_uri: REDIRECT_URI,
      }),
      {
        auth: {
          username: CLIENT_ID,
          password: CLIENT_SECRET,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    // Store the token
    localStorage.setItem("bitbucket_token", response.data.access_token);
    localStorage.setItem(
      "bitbucket_refresh_token",
      response.data.refresh_token
    );
    localStorage.setItem(
      "bitbucket_token_expiry",
      Date.now() + response.data.expires_in * 1000
    );

    return response.data;
  } catch (error) {
    console.error("Error exchanging code for token:", error);
    throw error;
  }
};

export const refreshToken = async () => {
  const refreshToken = localStorage.getItem("bitbucket_refresh_token");
  if (!refreshToken) {
    throw new Error("No refresh token available");
  }

  try {
    const response = await axios.post(
      BITBUCKET_TOKEN_URL,
      new URLSearchParams({
        grant_type: "refresh_token",
        refresh_token: refreshToken,
      }),
      {
        auth: {
          username: CLIENT_ID,
          password: CLIENT_SECRET,
        },
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );

    // Update stored tokens
    localStorage.setItem("bitbucket_token", response.data.access_token);
    localStorage.setItem(
      "bitbucket_refresh_token",
      response.data.refresh_token
    );
    localStorage.setItem(
      "bitbucket_token_expiry",
      Date.now() + response.data.expires_in * 1000
    );

    // Clear cache on token refresh
    clearCache();

    return response.data;
  } catch (error) {
    console.error("Error refreshing token:", error);
    localStorage.removeItem("bitbucket_token");
    localStorage.removeItem("bitbucket_refresh_token");
    localStorage.removeItem("bitbucket_token_expiry");
    throw error;
  }
};

const authApi = {
  getAuthUrl,
  exchangeCodeForToken,
  refreshToken,
};

export default authApi;
